import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "typeInput",
    "studentFields",
    "staffFields",
    "alumniFields",
    "employeeFields",
    "jobRoleField",
    "parentFields"
  ]

  static values = {
    studentId: Number,
    staffId: Number,
    alumniId: Number,
    employeeId: Number,
    parentId: Number
  }

  connect() {
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    this.toggleVisibility(this.studentFieldsTarget, this.isStudentSelected())
    this.toggleVisibility(this.staffFieldsTarget, this.isStaffSelected())
    this.toggleVisibility(this.alumniFieldsTarget, this.isAlumniSelected())
    this.toggleVisibility(this.employeeFieldsTarget, this.isEmployeeSelected())
    this.toggleVisibility(this.jobRoleFieldTarget, this.isAlumniSelected() || this.isEmployeeSelected())
    this.toggleVisibility(this.parentFieldsTarget, this.isParentSelected())
  }

  toggleVisibility(element, shouldShow) {
    if (!element) return

    if (shouldShow) {
      element.classList.remove("hidden")
    } else {
      element.classList.add("hidden")
    }
  }

  isStudentSelected() {
    return this.studentIdValue === this.selectedTypeId
  }

  isStaffSelected() {
    return this.staffIdValue === this.selectedTypeId
  }

  isAlumniSelected() {
    return this.alumniIdValue === this.selectedTypeId
  }

  isEmployeeSelected() {
    return this.employeeIdValue === this.selectedTypeId
  }

  isParentSelected() {
    return this.parentIdValue === this.selectedTypeId
  }

  get selectedTypeId() {
    return parseInt(this.typeInputTarget.value, 10)
  }
}
